import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { HOMI_STORAGE } from '@lyceo/homi/shared/util';
import { LoginSettingsState } from './login-settings.reducer';

export function loginSettingsLocalStorageSyncReducer(
  reducer: ActionReducer<LoginSettingsState>,
): ActionReducer<LoginSettingsState> {
  return localStorageSync({
    keys: ['website'],
    rehydrate: true,
    removeOnUndefined: true,
    storageKeySerializer: (key) => `${HOMI_STORAGE}/login-settings/${key}`,
  })(reducer);
}
